
import { carryOverLabel, describeAppliesTo, describeStates, planAka, planCountLabel } from '~/util/plan-notes'

// The Plan Notes page's Notes tab: one row per note with what it covers, its
// state rule, its reach (a rule note's plan count, a pinned note's copy on
// next year's plan) and its actions.
export default {
    props: {
        items: { type: Array, default: () => [] },
        year: { type: Number, required: true },
        loading: { type: Boolean, default: false },
        error: { type: String, default: null },
    },
    data () {
        return {
            expanded: {},
            fields: [
                { key: 'note', label: 'Note', thStyle: { width: '35%' } },
                { key: 'applies', label: 'Applies to' },
                { key: 'states', label: 'States' },
                { key: 'coverage', label: 'Coverage' },
                { key: 'active', label: 'Active' },
                { key: 'actions', label: '' },
            ],
        }
    },
    methods: {
        describeAppliesTo,
        describeStates,
        planAka,
        coverage (note) {
            return carryOverLabel(note, this.year) || planCountLabel(note, this.year)
        },
    },
}
